export default {
  orders: state => state.orders,
  order: state => state.order,

  loading: state => state.loading,
  error: state => state.error,
  message: state => state.message,
  orderErrorMessage: state => state.orderErrorMessage,
  
  filters: state => state.filters,
  pagination: state => state.pagination,

  isEmpty: state => state.users.length === 0
}